import React from 'react';
import { Section } from './ui/Section';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  return <Section className="bg-navy-900" dark={true} data-id="element-116">
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-117">
        {/* Para Ti */}
        <div className="space-y-8" data-id="element-118">
          <h3 className="text-2xl font-serif text-gold-400 flex items-center gap-3" data-id="element-119">
            <CheckCircleIcon className="w-6 h-6" data-id="element-120" />
            Esto es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-121">
            {['Tienes 40+ y tu mente se acelera por la noche', 'Te despiertas entre las 2–4am y te cuesta volver a dormir', 'Estás cansada de consejos vagos y quieres un método simple', 'Quieres un enfoque natural que aún se sienta práctico'].map((item, i) => <li key={i} className="flex gap-4 text-cream-100/80" data-id="element-122">
                <span className="w-1.5 h-1.5 rounded-full bg-gold-400 mt-2.5 flex-shrink-0" data-id="element-123" />
                <span data-id="element-124">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* No Es Para Ti */}
        <div className="space-y-8 md:border-l md:border-navy-700 md:pl-12" data-id="element-125">
          <h3 className="text-2xl font-serif text-cream-500 flex items-center gap-3 opacity-70" data-id="element-126">
            <XCircleIcon className="w-6 h-6" data-id="element-127" />
            Esto no es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-128">
            {['Necesitas tratamiento médico para insomnio severo sin apoyo profesional', 'Sospechas de apnea del sueño y no te harás una evaluación', 'Quieres una solución de un solo paso que te "noquee"'].map((item, i) => <li key={i} className="flex gap-4 text-cream-100/50" data-id="element-129">
                <span className="w-1.5 h-1.5 rounded-full bg-navy-600 mt-2.5 flex-shrink-0" data-id="element-130" />
                <span data-id="element-131">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}